export default __webpack_public_path__ + "static/5-tips-for-travelling-around-europe-in-winter-keeping-warm-1c7b99387dc84c68b15d0730d906921a.jpg";